import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Box, Spinner, Heading, Button, useToast } from "@chakra-ui/react";
import SignalCreator from "./SignalCreator";
import Navbar from "./Navbar";
import ProductSignalSelect from "./ProductSignalSelect";
import { getDeal, getProductByCode } from "./services/MrcaiAPI";

export const fetchProduct = async (code) => {
  const product = await getProductByCode(code);
  if (!product) {
    throw new Error(`Failed to fetch product for code: ${code}`);
  }
  return product;
};

const SignalCreatorPage = () => {
  const { productCode, dealId } = useParams();
  const [product, setProduct] = useState(null);
  const [deal, setDeal] = useState(null);
  const [loading, setLoading] = useState(true);
  const toast = useToast();
  const navigate = useNavigate();

    useEffect(() => {
      fetchProduct(productCode).then(setProduct);
    }, [productCode]);

  useEffect(() => {
    const fetchDeal = async () => {
      try {
        setDeal(await getDeal(dealId));
      } catch (err) {
        toast({ title: "Failed to load deal", description: err.message, status: "error" });
      } finally {
        setLoading(false);
      }
    };
    fetchDeal();
  }, [productCode, dealId]);

  if (loading) return <Spinner size="xl" />;

  return (
    <Box position="relative" width="100%" minHeight="100vh">
      <Navbar />
      <SignalCreator contractInstance={deal} product={product} productTemplate={null}/>

    </Box>
  );
};

export default SignalCreatorPage;
